import { Routing } from "../../pages/router/router";
import { BurgerMenu } from "../burgermenu/burgermenu";
import { NavBar } from "../navbar/navbar";



/**
 * @const Navigation manages all the navigation system, with the burger menu, the navigation bar and the routing system
 * @param properties open {boolean} true if the burger menu is open else false
 * @returns {JSX.Element} HTML content
 */

const Navigation = (properties: { open: boolean }) => {

    /* if the open is true the burger menu is display */
    if ((properties.open)) {
        return (
            <>
                <div className="container nav">
                    <BurgerMenu />
                </div>
                <div className="container root">
                    <Routing  />
                </div>
            </>
        );
    }
    return (
        <>
            <div className="container nav">
                <NavBar />
            </div>
            <div className="container root">
                <Routing />
            </div>
        </>
    );

};

export { Navigation };
